import { FunctionComponent } from 'react'
import { Spinner } from '@fluentui/react-spinner'
import { makeStyles } from '@griffel/react'
import { tokens } from '@fluentui/tokens'

const useClasses = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: tokens.spacingHorizontalL
  },
  spinner: {
    position: 'absolute'
  }
})

/** Displays loader while performing lengthy operation. */
export const Loader: FunctionComponent<{ size?: 'sm' | 'md' | 'lg' }> = ({ size }) => {
  const classes = useClasses()

  return (
    <div className={classes.root}>
      <Spinner className={classes.spinner} size={size === 'sm' ? 'tiny' : size === 'lg' ? 'huge' : 'medium'} />
    </div>
  )
}